import Vue from 'vue'
import Vuex from 'vuex'
import downLoadProgress from './modules/downLoadProgress'
import right from '@/store/modules/right'
import publicProgress from '@/store/modules/publicProgress'
import rightMenu from "@/store/modules/rightMenu";
import resultListName from "@/store/modules/resultListName";
import passPdfFile from "@/store/modules/passPdfFile";

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    downLoadProgress,
    right,
    publicProgress,
    rightMenu,
    resultListName,
    passPdfFile,
  },
})
